export default __webpack_public_path__ + "static/media/table-variation-card.826473c3.svg";